import React, { useState } from "react";
import { client } from "../../client";
import { images } from "./../../constants";
import "./Footer.scss";

const Footer = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [isSubmit, setIsSubmit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleForm = (ev) => {
    const { name, value } = ev.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const submitForm = () => {
    setIsLoading(true);

    const contact = {
      _type: "contact",
      name: formData.name,
      email: formData.email,
      message: formData.message,
    };
    client.create(contact).then((_) => {
      setIsLoading(false);
      setIsSubmit(true);
    });
  };

  const { name, email, message } = formData;
  return (
    <div id="contact" className="app__footer">
      <div className="head-text">Chat with me</div>
      <div className="app__footer-container">
        <div className="app__footer-contact">
          <div className="footer-email">
            <img src={images.email} alt="email msg" />
            <a href="mailto:kimoomar007@gmail.com" className="p-text">
              kimoomar007@gmail.com
            </a>
          </div>

          <div className="footer-phone">
            <img src={images.mobile} alt="phone call" />
            <a href="tel:+201092346077" className="p-text">
              +201092346077
            </a>
          </div>
        </div>
        {!isSubmit ? (
          <div className="app__footer-form">
            <div className="app__flex">
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={name}
                onChange={handleForm}
              />
            </div>
            <div className="app__flex">
              <input
                type="email"
                name="email"
                placeholder="Enter Email"
                value={email}
                onChange={handleForm}
              />
            </div>
            <div className="msg-user">
              <textarea
                name="message"
                value={message}
                id="message"
                placeholder="Message"
                onChange={handleForm}
              ></textarea>
            </div>

            <button className="submit" onClick={submitForm}>
              {!isLoading ? "Send a Message" : "sending..."}
            </button>
          </div>
        ) : (
          <div className="app__footer-form app__flex">
            <h2>Thank you for getting in touch</h2>
          </div>
        )}
      </div>
    </div>
  );
};

export default Footer;
